export const defaultAudioList = [
  {
    name: "Audio1",
    id: "audio1",
    metadata: {
      description: "Artist1",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio1.mp3",
    type: "audio",
  },
  {
    name: "Audio2",
    id: "audio2",
    metadata: {
      description: "Artist2",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio2.mp3",
    type: "audio",
  },
  {
    name: "Audio3",
    id: "audio3",
    metadata: {
      description: "Artist3",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio3.mp3",
    type: "audio",
  },
  {
    name: "Audio4",
    id: "audio4",
    metadata: {
      description: "Artist4",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio4.mp3",
    type: "audio",
  },
  {
    name: "Audio5",
    id: "audio5",
    metadata: {
      description: "Artist5",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio5.mp3",
    type: "audio",
  },
  {
    name: "Audio6",
    id: "audio6",
    metadata: {
      description: "Artist6",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio6.mp3",
    type: "audio",
  },
];

export const defaultVideoList = [
  {
    name: "Video1",
    id: "video1",
    metadata: {
      description: "Artist1",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video1.mp4",
    type: "video",
  },
  {
    name: "Video2",
    id: "video2",
    metadata: {
      description: "Artist2",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video2.mp4",
    type: "video",
  },
  {
    name: "Video3",
    id: "video3",
    metadata: {
      description: "Artist2",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video3.mp4",
    type: "video",
  },
];

export const DEFAULT_HLS_ROLE_KEY = "HLS_VIEWER_ROLE";
export const DEFAULT_HLS_VIEWER_ROLE = "hls-viewer";
export const QUERY_PARAM_SKIP_PREVIEW = "skip_preview";
export const QUERY_PARAM_SKIP_PREVIEW_HEADFUL = "skip_preview_headful";
export const QUERY_PARAM_NAME = "name";
export const QUERY_PARAM_VIEW_MODE = "ui_mode";
export const QUERY_PARAM_AUTH_TOKEN = "auth_token";
export const UI_MODE_ACTIVE_SPEAKER = "activespeaker";
export const UI_MODE_GRID = "grid";
export const MAX_TOASTS = 5;
export const RTMP_RESOLUTION_IGNORED_WARNING_TEXT =
  "Resolution will be ignored when HLS is on";
export const RTMP_RECORD_RESOLUTION_MIN = 480;
export const RTMP_RECORD_RESOLUTION_MAX = 1280;
export const RTMP_RECORD_DEFAULT_RESOLUTION = {
  width: 1280,
  height: 720,
};

export const APP_DATA = {
  uiSettings: "uiSettings",
  chatOpen: "chatOpen",
  chatDraft: "chatDraft",
  appConfig: "appConfig",
};
export const UI_SETTINGS = {
  isAudioOnly: "isAudioOnly",
  isHeadless: "isHeadless",
};

export const APPOINTMENT_STATUS_CODES = {
  PROPOSED: 'proposed',
  PENDING: 'pending',
  ARRIVED: 'arrived',
  FULFILLED: 'fulfilled',
  CANCELLED: 'cancelled',
  NO_SHOW: 'noshow',
  ENTERED_IN_ERROR: 'entered-in-error',
  CHECKED_IN: 'checked-in',
  WAIT_LIST: 'waitlist',
  BOOKED: 'booked',
  SCHEDULED: 'booked',
  CHECKED_OUT: 'checked-out',
  RESCHEDULED: 'rescheduled',
  DECLINED: 'declined',
  ACCEPTED: 'accepted',
  NEEDS_ACTION: 'needs-action',
};

export const MLOV_CATEGORY = {
  PERSON_ADDRESS_TYPE: 'PersonAddressType',
  PERSON_ADDRESS_USE: 'PersonAddressUse',
  PERSON_CONTACT_TYPE: 'PersonContactType',
  PERSON_CONTACT_USE: 'PersonContactUse',
  PERSON_GENDER: 'PersonGender',
  USER_TYPE: 'UserType',
  CUSTOMER_TYPE: 'CustomerType',
  FORM_RESOURCE: 'FormResource',
  CONVERSATION_STATUS: 'ConversationStatus',
  RELATIONS: 'Relations',
  SCHEDULE_LOCATION_TYPE: 'ScheduleLocationType',
  TAGGER_TYPE: 'TaggerType',
  LABEL_TYPE: 'LabelType',
  TASK_STATUS: 'TaskStatus',
  USER_ROLES: 'UserRoles',
  CARE_JOURNEY_DURATION: 'CareProgramDuration',
  OBSERVATION_CATEGORY: 'ObservationCategory',
  RECENT_ITEM_TYPES: 'RecentItemTypes',
  APPOINTMENT_TYPE_CATEGORY: 'AppointmentTypeCategory',
  APPOINTMENT_STATUS: 'AppointmentStatus',
  GroupType: 'GroupType',
  GroupMemberType: 'GroupMemberType',
  APPOINTMENT_PARTICIPANT_STATUS: 'AppointmentParticipantStatus',
  TASK_PRIORITY: 'TaskPriority',
  FORM_STATUS: 'FormStatus',
  TASK_ENTITY_TYPE: 'TaskEntityType',
  FORM_SOURCE: 'FormSource',
  CONDITION_CLINICAL_STATUS: 'ConditionClinicalStatus',
  IMMUNIZATION_STATUS: 'ImmunizationStatus',
  AVAILABILITY_TYPE: 'AvailabilityType',
  TASK_DISPLAY_CATEGORY: 'TaskDisplayCategory',
  TASK_DUE_DATE_CATEGORY: 'TaskDueDateCategory',
  CANNED_RESPONSE_TYPE: 'CannedResponseType',
  DOCUMENT_TYPE: 'DocumentType',
  DOCUMENT_SUBJECT_TYPE: 'DocumentSubjectType',
  PRIMARY_CARE_TEAM: 'CareTeamType',
  CARE_TEAM_USER_POOL: 'UserPoolType',
  VIRTUAL_NUMBER_ASSIGNEE: 'VirtualNumberAssignee',
  CONSENT: 'Consent',
  CONSENT_PROVIDER_TYPE: 'ConsentProviderType',
  TEAM_PREFERENCE: 'TeamPreference',
  PATIENT_CARE_JOURNEY_STATUS: 'PatientCareJourneyStatus',
  PREFERRED_COMMUNICATION_CHANNEL: 'PreferredCommunicationChannel',
  FEED_CATEGORY: 'FeedCategory',
  SEX_AT_BIRTH: 'SexAtBirth',
  USER_PREFERENCES_TYPE: 'UserPreferencesType',
  GROUP_WELCOME_MESSAGES_TYPE: 'GroupWelcomeMessagesType'
};
export const REMOTE_STOP_SCREENSHARE_TYPE = "REMOTE_STOP_SCREENSHARE";